export const addAuthToken = (config) => {
  //const token = localStorage.getItem("token");
  const accessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzkxOTU2OTExLCJpYXQiOjE3ODkzNjQ5MTEsImp0aSI6IjViMDUxN2ZlYTRmZDRmMThhMmJhNWJiODdiZmQyNmU2IiwidXNlcl9pZCI6MX0.NjRhho7pjxRsTxT4tZQr33YLz1S7FiFu88DwGH1HjX4";

  if (accessToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
};